<template>
	<UHeader mode="drawer">
		<UNavigationMenu
			:items="items"
			color="primary"
			variant="pill"
			:ui="{
				childLink: 'hover:bg-accented'
			}"
		>
			<template #localization>
				<Localization />
			</template>
		</UNavigationMenu>

		<template #left>
			<NuxtLink
				:to="localePath('/')"
				aria-label="Maverix Broadband"
			>
				<LogoFull class="w-auto h-8 sm:h-11 shrink-0 text-highlighted" />
			</NuxtLink>
		</template>

		<template #right>
			<UButton
				:label="loggedIn ? $t('links.your-account') : $t('links.sign-in')"
				:to="loggedIn ? accountUrl : localePath('/login')"
				:target="loggedIn ? '_blank' : '_self'"
				size="lg"
				color="primary"
				variant="outline"
				class="hidden sm:inline-flex uppercase"
			/>

			<UButton
				:label="$t('links.check-availability')"
				:to="localePath('/get-fiber')"
				size="lg"
				class="hidden sm:inline-flex uppercase"
			/>
		</template>

		<template #body>
			<div class="flex items-center gap-2 pb-4">
				<UButton
					:label="$t('links.check-availability')"
					:to="localePath('/get-fiber')"
					size="lg"
					color="neutral"
					variant="outline"
					:ui="{
						base: 'text-center inline-flex flex-1 flex-grow justify-center'
					}"
				/>
				<UButton
					:label="loggedIn ? $t('links.your-account') : $t('links.sign-in')"
					:to="loggedIn ? accountUrl : localePath('/login')"
					:target="loggedIn ? '_blank' : '_self'"
					size="lg"
					color="neutral"
					variant="outline"
					:ui="{
						base: 'text-center inline-flex justify-center w-2/5'
					}"
				/>
			</div>
			<UNavigationMenu
				:items="mobileItems"
				color="secondary"
				variant="pill"
				orientation="vertical"
				class="-mx-2.5"
			>
				<template #localization>
					<Localization />
				</template>
			</UNavigationMenu>
		</template>
	</UHeader>
</template>

<script setup lang="ts">
import { useAuth } from '@/composables/useAuth'
import type { NavigationMenuItem } from '@nuxt/ui'

const {
	loggedIn, accountUrl, getAuth
} = useAuth()
const localePath = useLocalePath()

defineProps({
	items: {
		type: Array as PropType<NavigationMenuItem[]>,
		required: true
	},
	mobileItems: {
		type: Array as PropType<NavigationMenuItem[]>,
		required: true
	}
})

onMounted(() => {
	getAuth()
})
</script>
